import {
  APP_INITIALIZER,
  EnvironmentProviders,
  Type,
  makeEnvironmentProviders,
} from '@angular/core';

/**
 * @returns true if app is run from options 2, 3, or 4
 *
 * Possible ways to run an app:
 * 1. from browser (either desktop or mobile)
 * 2. from shortcut created using "Add to Home screen" button
 * 3. from shortcut created using "Install PWA" functionality
 * 4. from an android app shell
 */
export function isPWA() {
  return isStandalonePWA() || isFullscreenPWA();
}

export function isStandalonePWA() {
  const mqStandalone = '(display-mode: standalone)';
  return (
    (window.navigator as any).standalone === true ||
    window.matchMedia(mqStandalone).matches
  );
}

export function isFullscreenPWA() {
  const mqFullscreen = '(display-mode: fullscreen)';
  return window.matchMedia(mqFullscreen).matches;
}

export function isIos() {
  const userAgent = window.navigator.userAgent.toLowerCase();
  const match = /iphone|ipad|ipod/.test(userAgent);
  return match;
}

export function emptyPromiseFactory() {
  return () => Promise.resolve();
}

export function eagerProvider(klass: Type<any>): EnvironmentProviders {
  return makeEnvironmentProviders([
    klass,
    {
      provide: APP_INITIALIZER,
      useFactory: emptyPromiseFactory,
      deps: [klass],
      multi: true,
    },
  ]);
}
